module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_home-cc6d1cb5bd57f1a7442354a0a30a9536.png";